module.exports = __webpack_public_path__ + "441cc8ebd537b9ab564358f4b7a52d23.pdf";